import { InspectionQueuePage } from "@/components/inspection/queue-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/inspection/queue")({
  component: InspectionQueuePage,
});
